import React from "react";
import { CLink } from "../common/customLink/CustomLink";
import { cn } from "@/lib/tailwind";

interface IProps {
  className?: string;
  data: {
    label: string;
    url: string;
  }[];
}

const ProductTags = ({ data, className }: IProps) => {
  return (
    <div className={cn(className)}>
      {data?.map(
        (item, idx) =>
          item?.label && item.label !== '-' && (
            <span key={idx}>
              {idx == 0 ? null : <span className="px-1 text-tertiary-6">-</span>}
              <CLink href={item?.url} className="text-tertiary-6 underline">
                {item.label}
              </CLink>
            </span>
          ),
      )}
    </div>
  );
};

export default ProductTags;
